import * as v from 'valibot'

export type LineActivationProviderSettingFormType = {
  messageApiAccessToken: string
  messageApiChannelSecret: string
  lineChannelId?: string
  liffId?: string
  lineFollowUrl?: string
}

export const validLineActivationProviderSettingFormSchema = v.object({
  messageApiAccessToken: v.pipe(
    v.string(),
    v.trim(),
    v.maxLength(255, '255文字以内で入力してください')
  ),
  messageApiChannelSecret: v.pipe(
    v.string(),
    v.trim(),
    v.maxLength(255, '255文字以内で入力してください')
  ),
  lineChannelId: v.optional(
    v.pipe(
      v.string(),
      v.trim(),
      v.maxLength(255, '255文字以内で入力してください')
    )
  ),
  liffId: v.optional(
    v.pipe(
      v.string(),
      v.trim(),
      v.maxLength(255, '255文字以内で入力してください')
    )
  ),
  lineFollowUrl: v.optional(
    v.pipe(
      v.string(),
      v.trim(),
      v.check(value => {
        if (value !== '') {
          try {
            new URL(value)
          } catch {
            return false
          }
        }
        return true
      }, 'URLの形式が正しくありません')
    )
  ),
})

export type LineActivationProviderSettingFormErrors = v.FlatErrors<
  typeof validLineActivationProviderSettingFormSchema
>

export type LineActivationProviderSettingFormErrorPath = keyof NonNullable<
  LineActivationProviderSettingFormErrors['nested']
>

export type LineActivationProviderSettingFormErrorManager = {
  get: (path: LineActivationProviderSettingFormErrorPath) => string | undefined
}
